import script from "./kreadChart.vue?vue&type=script&setup=true&lang=js"
export * from "./kreadChart.vue?vue&type=script&setup=true&lang=js"

import "./kreadChart.vue?vue&type=style&index=0&id=79987d3e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79987d3e"]])

export default __exports__